import React, { useContext, useState, useEffect } from "react";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import { ArtContext } from "../Contexts/ArtContext";
import { useParams } from "react-router-dom";
import Loading from "../pages/Loading";
import ReactGA from "react-ga";
import { CategoryContext } from "../Contexts/CategoryContext";
import { CollectionContext } from "../Contexts/CollectionContext";


const Product = () => {
  const { id } = useParams();
  const { arts, loading, error,fetchArtsByCategoryOrCollection} = useContext(ArtContext);
  const { fetchCategories } = useContext(CategoryContext);
  const { fetchCollections } = useContext(CollectionContext);
  const itemsPerPage = 9; // Number of rows needed
  const [currentPage, setCurrentPage] = useState(1);
  const [filteredArts, setFilteredArts] = useState([]);
  
  
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
    fetchCategories();
    fetchCollections();
    fetchArtsByCategoryOrCollection(id);
  }, [id]);
  
  useEffect(() => {
    setFilteredArts(arts);
  }, [arts]);
  
  const totalPages = Math.ceil(filteredArts.length / itemsPerPage);

  const handleClickNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handleClickPrev = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentItems = filteredArts.slice(startIndex, startIndex + itemsPerPage);

  const renderPageNumbers = () => {
    if (totalPages <= 3) {
      return Array.from({ length: totalPages }, (_, index) => (
        <span
          key={index}
          className={`mx-1 ${
            currentPage === index + 1 ? "text-black" : "text-gray-400"
          } font-semibold text-xl md:text-2xl`}
        >
          {index + 1}
        </span>
      ));
    }

    if (currentPage <= 2) {
      return (
        <>
          <span
            className={`mx-1 ${
              currentPage === 1 ? "text-black" : "text-gray-400"
            } font-semibold text-xl md:text-2xl`}
          >
            1
          </span>
          <span
            className={`mx-1 ${
              currentPage === 2 ? "text-black" : "text-gray-400"
            } font-semibold text-xl md:text-2xl`}
          >
            2
          </span>
          <span className="mx-1 text-gray-400 font-semibold text-xl md:text-2xl">
            ...
          </span>
          <span
            className={`mx-1 ${
              currentPage === totalPages ? "text-black" : "text-gray-400"
            } font-semibold text-xl md:text-2xl`}
          >
            {totalPages}
          </span>
        </>
      );
    }

    if (currentPage >= totalPages - 1) {
      return (
        <>
          <span
            className={`mx-1 ${
              currentPage === 1 ? "text-black" : "text-gray-400"
            } font-semibold text-xl md:text-2xl`}
          >
            1
          </span>
          <span className="mx-1 text-gray-400 font-semibold text-xl md:text-2xl">
            ...
          </span>
          <span
            className={`mx-1 ${
              currentPage === totalPages - 1 ? "text-black" : "text-gray-400"
            } font-semibold text-xl md:text-2xl`}
          >
            {totalPages - 1}
          </span>
          <span
            className={`mx-1 ${
              currentPage === totalPages ? "text-black" : "text-gray-400"
            } font-semibold text-xl md:text-2xl`}
          >
            {totalPages}
          </span>
        </>
      );
    }

    return (
      <>
        <span
          className={`mx-1 ${
            currentPage === 1 ? "text-black" : "text-gray-400"
          } font-semibold text-xl md:text-2xl`}
        >
          1
        </span>
        <span className="mx-1 text-gray-400 font-semibold text-xl md:text-2xl">
          ...
        </span>
        <span
          className={`mx-1 ${
            currentPage === currentPage ? "text-black" : "text-gray-400"
          } font-semibold text-xl md:text-2xl`}
        >
          {currentPage}
        </span>
        <span className="mx-1 text-gray-400 font-semibold text-xl md:text-2xl">
          ...
        </span>
        <span
          className={`mx-1 ${
            currentPage === totalPages ? "text-black" : "text-gray-400"
          } font-semibold text-xl md:text-2xl`}
        >
          {totalPages}
        </span>
      </>
    );
  };

  return (
    <div>
      <NavBar />
      {loading ? (
        <Loading /> // Display the Loading component while loading is true
      ) : error ? (
        <div>Error: {error.message}</div>
      ) : (
      <div className="py-16 px-4 md:px-24 mt-8">
        <div className="flex justify-between items-center mb-8">
          <h2 className="text-4xl md:text-6xl ml-4">Artworks</h2>
          <a
            href="/shop"
            className="text-black underline text-xl md:text-2xl font-semibold underline-offset-8 decoration-1"
          >
            View all
          </a>
        </div>
        {loading ? (
          <div>Loading...</div>
        ) : error ? (
          <div>Error: {error.message}</div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {currentItems.map((item) => (
              <div key={item._id} className="text-black p-4 rounded-lg">
                <a href={`/product/${item._id}`}>
                  <img
                    src={`${item.artImageCover}`}
                    alt={item.artName}
                    className="w-full h-auto mb-4 rounded-lg"
                  />
                </a>
                <h3 className="text-2xl md:text-3xl font-semibold tracking-wide">
                  {item.artName}
                </h3>
                <p className="text-xl md:text-2xl font-light">${item.editions[0].price}</p>
              </div>
            ))}
          </div>
        )}
        <div className="flex justify-between items-center mt-8 space-x-4">
          <button
            onClick={handleClickPrev}
            disabled={currentPage === 1}
            className={`${
              currentPage === 1 ? "text-gray-400" : "text-black"
            } font-semibold text-xl md:text-2xl flex items-center`}
          >
            <span className="mr-2">&lt; Prev</span>
          </button>
          <div className="flex space-x-2">{renderPageNumbers()}</div>
          <button
            onClick={handleClickNext}
            disabled={currentPage === totalPages}
            className={`${
              currentPage === totalPages ? "text-gray-400" : "text-black"
            } font-semibold text-xl md:text-2xl flex items-center`}
          >
            <span className="ml-2">Next &gt;</span>
          </button>
        </div>
      </div>)}
      <Footer />
    </div>
  );
};

export default Product;
